export const STATISTICS_TABS = [
  {
    value: 'registrations',
    label: 'Registrations',
    countLabel: 'Registrations',
    charts: [
      { metric: 'new_companies', title: 'New organizations' },
      { metric: 'new_users', title: 'New users' },
    ],
  },
  {
    value: 'job_ad_visits',
    label: 'Job ad visits',
    countLabel: 'Page views',
    supportsUnique: true,
    charts: [
      { metric: 'job_ad_visits_website', title: 'Website' },
      { metric: 'job_ad_visits_app', title: 'In app' },
    ],
  },
  {
    value: 'blog_visits',
    label: 'Blog visits',
    countLabel: 'Page views',
    supportsUnique: true,
    charts: [
      { metric: 'blog_visits_website', title: 'Website' },
      { metric: 'blog_visits_app', title: 'In app' },
    ],
  },
];
